<script lang="ts">
  import Button from "../atoms/Button.svelte";
  import Heading from "../atoms/Heading.svelte";
  import { fly } from "svelte/transition";
  import Text from "../atoms/Text.svelte";

  interface Props {
    campaign: string;
    onCancel: () => void;
  }

  let { campaign, onCancel }: Props = $props();
</script>

<div
  style="background-color: rgba(255,255,255,0.5);"
  class="mr-2 z-50 fixed top-0 bottom-0 left-0 right-0 flex justify-center items-center"
>
  <div
    in:fly={{ y: 500, duration: 500 }}
    out:fly={{ y: -500, duration: 500 }}
    class=" bg-white shadow-CookieConsent py-4 px-2 sm:px-14 flex flex-col justify-center"
  >
    {#if campaign}
      <div class="text-center mb-4">
        <Heading>Du är på väg att lämna<br /> ditt unika kampanjerbjudande.</Heading>
        <Text variant="primary">Är du säker på att du vill lämna?</Text>
      </div>
    {:else}
      <Heading class="mb-4">Du är på väg att lämna elavtalsidan</Heading>
    {/if}
    <ul class="self-center inline-flex flex-col justify-center items-stretch">
      <li>
        <a href="/" data-variant="primary" class=" btn my-1 w-full">Gå till startsidan</a>
      </li>
      <li>
        <a href="/kundservice/faq/?faqs=elavtal" data-variant="primary" class="btn my-1 w-full"
          >Jag har frågor och behöver hjälp</a
        >
      </li>
      <li>
        <Button animate={false} onClick={onCancel} variant="secondary" class=" my-1 w-full"
          >Avbryt</Button
        >
      </li>
    </ul>
  </div>
</div>
